import {systemLogsPlugin} from '../auditLogs/plugin';

export default systemLogsPlugin;
